/* eslint-disable */
import React, { ChangeEvent } from 'react';
import { Button } from '@eleveo/components-react';
import { SearchAddIcon } from '@eleveo/icons-react';
import { TFunction } from 'i18next';

export interface FileInputProps {
  onChange: (file: File) => void;
  fileName: string | null;
  fileSize: string | null;
  t: TFunction;
  buttonTestId?: string;
  fileNameTestId?: string;
  fileSizeTestId?: string;
}

export class FileInput extends React.PureComponent<FileInputProps> {
  private inputRef = React.createRef<HTMLInputElement>();

  public render() {
    const { t, fileName, fileNameTestId, fileSize, fileSizeTestId } = this.props;

    return (
      <>
        {this.renderButton()}
        {fileName && (
          <p>
            <strong>{t('dataImport.selectedFile')}</strong>
            <span className="break-all" data-test-id={fileNameTestId}>
              {fileName}
            </span>{' '}
            <span data-test-id={fileSizeTestId}>{t('dataImport.sizeMB', { fileSize })}</span>
          </p>
        )}
        <input type="file" data-test-id="file-input" hidden ref={this.inputRef} onChange={this.onFileChange} />
      </>
    );
  }

  private renderButton = () => {
    const { buttonTestId, fileName, t } = this.props;

    if (fileName) {
      return;
    }

    return (
      <Button testId={buttonTestId} onClick={this.handleButtonClick}>
        <SearchAddIcon />
        {t('form.browse')}
      </Button>
    );
  };

  private handleButtonClick = () => this.inputRef.current && this.inputRef.current.click();

  private onFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { onChange } = this.props;
    const eventFiles = event.currentTarget.files;

    if (eventFiles && eventFiles.length > 0) {
      const file = eventFiles[0];
      onChange(file);
      this.clearInput();
    }
  };

  private clearInput = () => {
    if (this.inputRef.current) {
      this.inputRef.current.value = '';
    }
  };
}
